import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

const styles = (theme) => ({
  rowItem: {
    marginBottom: 16,
    fontSize: 12,
  },
  rowContainer: {
    display: "flex",
    maxWidth: 130,
    flexDirection: "column",
  },
  label: {
    color: theme.tooltipBorderColor,
  },
  value: {
    color: theme.TextColor,
    fontWeight: 600,
  },
});
const DetailsRenderer = ({ classes, data }) => {
  return (
    <Grid container spacing={24}>
      {data.map((listItem) => (
        <Grid
          item
          container
          direction="column"
          key={listItem.label}
          xs={4}
          className={classes.rowItem}
        >
          <span className={classes.label}>{listItem.label}</span>
          <span className={classes.value}>{listItem.value}</span>
        </Grid>
      ))}
    </Grid>
  );
};

export default withStyles(styles)(DetailsRenderer);
